// work data

export const Work = [
    {
        id:1,
        name:"NeuraChat Landing Page",
        description:"Highly powerful dark themed landing page for AI Chatting app",
        tags:["react","tailwind"],
        
        demo:"https://neura.dharmik.dev/",
        github:"#"
    },
    {
        id:2,
        name:"Dev Solutions Website",
        description:"A software solutions website sell software services and custom software products  ",
        tags:["react","tailwind"],
        
        demo:"https://dev.dharmik.dev/",
        github:"#"
        
    },
    {
        id:3,
        name:"Tempy",
        description:"Website build to sell templates for developers and startups.",
        tags:["react","styledcomponents","emotion"],
        
        demo:"https://tempy.dharmik.dev/",
        github:"#"
    },
    {
        id:4,
        name:"Real estate website",
        description:"A real estate website to showcase property listings and generate leads",
        tags:["react","vite","react-router"],
        
        demo:"https://tru.dharmik.dev/",
        github:"#"
       
    }
] 